import React from 'react'
import Skeleton from 'react-loading-skeleton'

const ProductDetailsLeftSideSkeleton = () => {
  return (
    <div className="flex-1">
      <div className="pb-6 border-b-2 border-[#ededed]">
        {/* SKU skeleton */}
        <div className="mb-4">
          <Skeleton
            width={120}
            height={28}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-full"
          />
        </div>

        {/* Product title skeleton */}
        <div className="mb-3">
          <Skeleton
            height={32}
            width="90%"
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="mb-2 !rounded-sm"
          />
          <Skeleton
            height={32}
            width="70%"
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
        </div>

        {/* Star rating skeleton */}
        <div className="mb-4 flex items-center gap-2">
          <div className="flex gap-1">
            {Array(5)
              .fill()
              .map((_, index) => (
                <Skeleton
                  key={index}
                  width={16}
                  height={16}
                  baseColor="#f1f5f9"
                  highlightColor="#e2e8f0"
                  className="!rounded-sm"
                />
              ))}
          </div>
          <Skeleton
            width={80}
            height={16}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
        </div>

        {/* Price section skeleton */}
        <div className="flex items-center lg:items-baseline gap-4 mb-4">
          <Skeleton
            width={120}
            height={45}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
          <Skeleton
            width={80}
            height={28}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-sm"
          />
          <Skeleton
            width={100}
            height={28}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-full ml-auto"
          />
        </div>

        {/* Color options skeleton */}
        <div className="mt-6">
          <Skeleton
            width={100}
            height={16}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="mb-2 !rounded-sm"
          />
          <div className="flex gap-3">
            {Array(4)
              .fill()
              .map((_, index) => (
                <Skeleton
                  key={index}
                  width={40}
                  height={40}
                  baseColor="#f1f5f9"
                  highlightColor="#e2e8f0"
                  className="!rounded-full"
                />
              ))}
          </div>
        </div>
      </div>

      {/* Attributes section skeleton */}
      <div className="mt-6">
        <div className="space-y-3">
          {Array(2)
            .fill()
            .map((_, index) => (
              <div
                key={index}
                className="flex justify-between items-center py-2"
              >
                <Skeleton
                  width={120 + index * 10}
                  height={16}
                  baseColor="#f8fafc"
                  highlightColor="#e2e8f0"
                  className="!rounded-sm"
                />
                <Skeleton
                  width={80 + index * 5}
                  height={16}
                  baseColor="#f8fafc"
                  highlightColor="#e2e8f0"
                  className="!rounded-sm"
                />
              </div>
            ))}
        </div>

        {/* Show more button skeleton */}
        <div className="mt-4">
          <Skeleton
            width={120}
            height={32}
            baseColor="#f1f5f9"
            highlightColor="#e2e8f0"
            className="!rounded-lg"
          />
        </div>
      </div>
    </div>
  )
}

export default ProductDetailsLeftSideSkeleton
